import { useEffect, useState } from 'react'
import CampaignService from '@forwardflow/services/CampaignService'
import { IFilterCriteria } from '@forwardflow/features/campaign-filter/interfaces/campaign-filter.types'
import { isFreeFlow } from '../../dev/devTools'

/**
 * Lead count for a set of filters from `estimated-leads`, debounced, or the
 * count we already know while it loads. `null` criteria = no count.
 */
export const useLeadCount = (
   criteria: IFilterCriteria[] | null,
   known?: number,
   delay = 400
) => {
   const [count, setCount] = useState<number | undefined>(known)
   const [loading, setLoading] = useState(false)
   const key = JSON.stringify(criteria)
   useEffect(() => {
      if (!criteria) {
         setCount(undefined)
         return
      }
      if (isFreeFlow()) {
         setCount(known ?? Math.max(5, (key.length * 7) % 140))
         return
      }
      let cancelled = false
      setLoading(true)
      const t = setTimeout(async () => {
         try {
            const res = await CampaignService.getEstimatedLeadsForCampaign(
               criteria as never
            )
            if (!cancelled) setCount(res?.count ?? known)
         } catch {
            if (!cancelled) setCount(known)
         } finally {
            if (!cancelled) setLoading(false)
         }
      }, delay)
      return () => {
         cancelled = true
         clearTimeout(t)
      }
      // eslint-disable-next-line react-hooks/exhaustive-deps
   }, [key])
   return { count, loading }
}
